import "./OrderTracking.module.css";
import Header from "@/reusable_sections/Header";
import OrderTrackingTimeline from "./sections/OrderTrackingTimeline";
import Footer from "@/reusable_sections/Footer";
export default function OrderTrackingPage() {
  return <div>
      <Header />
      <OrderTrackingTimeline />
      <Footer />
    </div>;
}